export default __webpack_public_path__ + "static/media/comm-twisted-histories-664x830.89b49d1d.jpg";